import { ConsoleSqlOutlined } from '@ant-design/icons'
import { ProviderAuthenticationClient } from '~/plugins/data-connector/authentication/client'
import { ProviderClient } from '../../abstract/provider.client'
import { ProviderSqlCommon } from '../common'

export const ProviderSqlClient: ProviderClient = {
  key: ProviderSqlCommon.key,
  authentication: ProviderAuthenticationClient.Form({
    ...ProviderSqlCommon.authentication,
    inputs: [
      {
        key: 'name',
        inputType: 'Input',
        propsFormItem: {
          label: 'Connection name',
          rules: [{ required: true }],
        },
        propsInput: {
          placeholder: 'staging',
        },
      },
      {
        key: 'url',
        inputType: 'Input',
        propsFormItem: {
          label: 'Database url (read-only)',
          rules: [{ required: true }],
        },
        propsInput: {
          placeholder: 'postgres://username:password@host:port/name',
        },
      },
    ],
  }),
  description: {
    label: 'SQL',
    icon: <ConsoleSqlOutlined />,
    triggers: [],
    actions: [],
  },
}
